<template>
  <div class="container">
    <div class="row justify-content-center align-items-center py-2 my-3">
      <p class="page-title-header-text mb-0">Please select your round to start WINNING!</p>
    </div>
    <hr class="line-break">
    <div class="round-container my-3" v-for="(round, index) in activeRounds" :key="index" v-if="selectedSport === 'Soccer'">
      <SoccerRound v-bind:round="round"/>
    </div>
    <div class="round-container my-3" v-for="(round, index) in activeRounds" :key="index" v-if="selectedSport === 'Cricket'">
      <CricketRound v-bind:round="round"/>
    </div>
    <div class="rounds-container my-3" v-for="(round, index) in activeRounds" :key="index" v-if="selectedSport === 'Olympics'">
      <OlympicsRound v-bind:round="round"/>
    </div>
  </div>
</template>

<script>
import {mapMutations, mapState} from "vuex";
import SoccerRound from "../components/SoccerRound";
import OlympicsRound from "../components/OlympicsRound";
import CricketRound from "../components/CricketRound";

export default {
  name: "Rounds",
  components: {
    SoccerRound,
    OlympicsRound,
    CricketRound,
  },
  data() {
    return {
      activeRounds: []
    }
  },
  computed: mapState(['selectedSport', 'sportsWithActiveRounds', 'selectedLeague']),
  methods: {
    ...mapMutations(['setSelectedLeague', 'setSelectedRound']),

    getOlympicsButtonText(hasPredictions) {
      if (hasPredictions) return 'Edit predictions';
      else return 'Predict round';
    },
    getImage(imagePath) {
      return require(`../assets/${imagePath}`);
    },
    onRoundClicked(round, sport) {
      this.setSelectedRound(round);
      if (round.HasPredictions) {
        this.$router.push(`predictions/${sport.toLowerCase()}/view-predictions`);
      } else {
        this.$router.push(`predictions/${sport.toLowerCase()}/make-predictions`);
      }
    },
    clearState() {
      this.activeRounds = [];
    }
  },
  created() {

    this.clearState();
    const selectedActiveSports = this.sportsWithActiveRounds.get(this.selectedSport);
    console.log(selectedActiveSports);
    this.activeRounds = selectedActiveSports.get(this.selectedLeague);
    console.log(this.activeRounds)
  }
}
</script>

<style scoped lang="scss">
.page-title-header-text {
  color: $subheading-text-color;
}

</style>
